import { IonImg } from '@ionic/react'
import React, { HTMLAttributes } from 'react'
import { getStyleForPHI, IPHIComponent } from '../phi/phi.component'
import { IShowPhotoViewerProps } from '../../features/attachments/page/Attachments.page'

export interface IImage extends HTMLAttributes<HTMLIonImgElement>, IPHIComponent {
  src?: string
  alt?: string
  dataTestID?: string
  onClickAction?: (props: IShowPhotoViewerProps) => void
}

const ImageComponent: React.FC<IImage> = (props: IImage) => {
  const { src, alt, dataTestID, isPHI, onClickAction } = props

  return (
    <div data-private={isPHI} style={getStyleForPHI(isPHI)}>
      <IonImg
        data-testid={dataTestID}
        src={src}
        alt={alt}
        {...(onClickAction && { onClick: () => onClickAction({ src, alt }) })}
        {...props}
      />
    </div>
  )
}

export default ImageComponent
